export function returnExchangeForm() {
  return {
    selectedItems: [],
    selectedImages: [],
    selectedFiles: [],
    maxImages: 5,
    maxFileSize: 5 * 1024 * 1024,
    showConfirmModal: false,
    agreedToTerms: false,
    pendingFormEvent: null,
    isConfirmedSubmit: false,
    requestType: 'exchange_item',
    isReturnType: false,

    init() {
      const form = this.$el.querySelector('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          this.handleFormSubmit(e);
        });
      }

      this.checkInitialRequestType();
    },

    handleFormSubmit(event) {
      if (this.isConfirmedSubmit) {
        this.isConfirmedSubmit = false;


        if (this.selectedFiles && this.selectedFiles.length > 0) {
          event.preventDefault();

          const form = document.querySelector('input[value="提交申請"]').closest('form');
          this.performFormSubmitWithFiles(form);
        } else {
          return;
        }
        return;
      }

      // 防止預設表單提交
      event.preventDefault();

      this.pendingFormEvent = event;

      this.openConfirmModal();
    },

    openConfirmModal() {
      this.showConfirmModal = true;
      this.agreedToTerms = false;
      this.$refs.confirmModal.showModal();
    },

    closeConfirmModal() {
      this.showConfirmModal = false;
      this.agreedToTerms = false;
      this.pendingFormEvent = null;
      this.$refs.confirmModal.close();
    },

    confirmSubmit() {
      if (!this.agreedToTerms) {
        return;
      }

      this.isConfirmedSubmit = true;

      this.closeConfirmModal();

      setTimeout(() => {
        const submitButton = document.querySelector('input[value="提交申請"]');

        if (submitButton) {
          submitButton.click();
        }
      }, 100);
    },

    performFormSubmitWithFiles(form) {
      const formData = new FormData(form);

      // 添加圖片檔案
      this.selectedFiles.forEach((file) => {
        formData.append('images[]', file);
      });

      // 手動提交表單
      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]')?.content,
          'Accept': 'text/html'
        }
      }).then(response => {
        if (response.ok) {
          // 提交成功，導向到結果頁面
          return response.text();
        } else {
          // 提交失敗，重新顯示表單
          return response.text();
        }
      }).then(html => {
        // 更新頁面內容
        document.open();
        document.write(html);
        document.close();
      }).catch(() => {
        alert('提交失敗，請重試');
      });
    },

    performFormSubmit() {
      if (this.pendingFormEvent) {
        this.isConfirmedSubmit = true;

        const submitButton = document.querySelector('input[value="提交申請"]');
        if (submitButton) {
          submitButton.click();
        }
      }
    },

    handleFileSelect(event) {
      const files = Array.from(event.target.files);

      if (this.selectedImages.length + files.length > this.maxImages) {
        alert(`最多只能上傳 ${this.maxImages} 張圖片`);
        return;
      }

      files.forEach(file => {
        if (file.size > this.maxFileSize) {
          alert(`圖片 "${file.name}" 超過 5MB 限制`);
          return;
        }

        if (!file.type.startsWith('image/')) {
          alert(`檔案 "${file.name}" 不是有效的圖片格式`);
          return;
        }

        this.selectedFiles.push(file);

        const reader = new FileReader();
        reader.onload = (e) => {
          this.selectedImages.push({
            url: e.target.result,
            name: file.name,
            file: file
          });
        };
        reader.readAsDataURL(file);
      });

      event.target.value = '';
    },

    removeImage(index) {
      this.selectedImages.splice(index, 1);
      this.selectedFiles.splice(index, 1);
    },

    get hasSelectedItems() {
      return this.selectedItems.length > 0;
    },

    get selectedItemsCount() {
      return this.selectedItems.length;
    },

    get canAddMoreImages() {
      return this.selectedImages.length < this.maxImages;
    },

    get remainingSlots() {
      return this.maxImages - this.selectedImages.length;
    },

    handleRequestTypeChange(value) {
      this.requestType = value;
      this.isReturnType = (value === 'return_item');

      if (this.isReturnType) {
        this.selectAllItems();
        this.disableItemSelection();
      } else {
        this.enableItemSelection();
        this.selectedItems = [];
      }
    },

    selectAllItems() {
      const allItemIds = Array.from(document.querySelectorAll('[data-order-item-id]'))
        .map(el => el.dataset.orderItemId);
      this.selectedItems = allItemIds;
    },

    disableItemSelection() {
      document.querySelectorAll('[data-order-item-id]').forEach(checkbox => {
        checkbox.disabled = true;
      });
    },

    enableItemSelection() {
      document.querySelectorAll('[data-order-item-id]').forEach(checkbox => {
        checkbox.disabled = false;
      });
    },

    checkInitialRequestType() {
      const returnRadio = document.querySelector('input[name="return_exchange[request_type]"][value="return_item"]');
      const exchangeRadio = document.querySelector('input[name="return_exchange[request_type]"][value="exchange_item"]');

      if (returnRadio && returnRadio.checked) {
        this.handleRequestTypeChange('return_item');
      } else if (exchangeRadio && exchangeRadio.checked) {
        this.handleRequestTypeChange('exchange_item');
      }
    }
  };
}



